import { Component, EventEmitter, Output } from "@angular/core";
import { SidePanelService } from "../../../common/services/side-panel.service";

@Component({
    templateUrl: "./workflow-builder-tabs.component.html",
    selector: "workflow-builder-tabs",
    standalone: false
})

export class WorkflowBuilderTabsComponent {
    currentTab: string = "diagram";
    @Output() setTabEvent = new EventEmitter<string>();

    constructor(public sidePanelService: SidePanelService) {
        
    }
    ngOnInit() {
        this.showTab("diagram");
    }

    showTab(tab: string): void {
        this.currentTab = tab;
        this.sidePanelService.toggleSidePanel(false);
        this.setTabEvent.emit(tab);
    }
}
